export const DEFAULT_BINDER_URL = "https://binder.libretexts.org";
export const DEFAULT_BINDER_REPO = "libretexts/default-env";
export const DEFAULT_CONFIG = {
  requestKernel: true,
  binderOptions: {
    repo: DEFAULT_BINDER_REPO,
    ref: "HEAD",
    binderUrl: DEFAULT_BINDER_URL,
  },
  mathjaxUrl: "false", // disable loading mathjax through thebelab https://thebe.readthedocs.io/en/stable/config_reference.html?highlight=mathjax
};

export const LANGUAGE_DICTIONARY = {
  "Python 3": "python",
  Julia: "julia",
  R: "r",
  Octave: "octave",
  SageMath: "sagemath",
  "C++": "text/x-c++src",
};

export const DATA_LANGUAGE_DICTIONARY = {
  python: "Python 3",
  julia: "Julia",
  r: "R",
  octave: "Octave",
  sagemath: "SageMath",
  "text/x-c++src": "C++",
};
